

/// <reference path="NumberSerialSequence.ts" />

// Generated class DocumentSequence_ManagedObject

class DocumentSequence_ManagedObject extends NumberSerialSequence
{
}
